import { VeiculoMarcaModel } from '../models/veiculo_marca';
import { BaseService } from "./BaseService";
import { DefaultResponse, ServiceProps } from "./types";

const ENDPOINT = `${BaseService.BASE_URL}/veiculo-marca`;

export class VeiculoMarcaService extends BaseService {
    public static async get(props: ServiceProps = { limit: 100, page: 1 }): Promise<DefaultResponse<VeiculoMarcaModel>> {
        return await this.GET<VeiculoMarcaModel>(`${ENDPOINT}?limit=${props.limit}&page=${props.page}`);
    }

    public static async getId(id: number): Promise<DefaultResponse<VeiculoMarcaModel>> {
        return await this.GET<VeiculoMarcaModel>(`${ENDPOINT}/${id}`);
    }

    public static async add(model: VeiculoMarcaModel): Promise<DefaultResponse<VeiculoMarcaModel>> {
        return await this.POST<VeiculoMarcaModel>(`${ENDPOINT}`, model);
    }

    public static async update(model: VeiculoMarcaModel): Promise<DefaultResponse<VeiculoMarcaModel>> {
        return await this.PATCH<VeiculoMarcaModel>(`${ENDPOINT}/${model.id}`, model);
    }

    public static async delete(id: number): Promise<DefaultResponse<VeiculoMarcaModel>> {
        return await this.DELETE(`${ENDPOINT}/${id}`);
    }
}